
import React from "react";
import ReactDOM from "react-dom/client";
import { Modal } from "react-bootstrap";
import currentLocation from "../assets/icons/current_location.svg";

type LocationDialogProps = {
    address: string;
    postalCode: string;
    handleLocationConfirm: () => void;
    handleLocationChange: () => void;
    onClose: () => void;
};

const LocationDialog: React.FC<LocationDialogProps> & {
    show: (
        address: string,
        postalCode: string,
        handleLocationConfirm: () => void,
        handleLocationChange: () => void
    ) => void;
} = ({ address, postalCode, handleLocationConfirm, handleLocationChange , onClose }) => {

    const handleConfirm = () => {
        handleLocationConfirm();
        onClose();
    };

    const handleChange = () => {
        handleLocationChange();
        onClose();
    };

    return (
        <Modal show={true} onHide={onClose} centered className="custom-modal" backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Location Information</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="custom-track-model">
                    <img src={currentLocation} alt="track" className="custom-track-model-img" />
                    <div className="current-location-contain">
                        <div className="current-location-address">
                            <span>Address:</span>
                            <span className="current-location-address-value">
                                {address}
                            </span>
                        </div>
                        <div className="current-location-address">
                            <span>Postal Code:</span>
                            <span className="current-location-address-value">{postalCode}</span>
                        </div>
                    </div>
                    <div className="custom-modal-bottom" style={{ marginBottom: "30px" }}>
                        <button className="custom-secondary-button" onClick={handleConfirm}>
                            Confirm
                        </button>
                        <button className="custom-primary-button" onClick={handleChange}>
                            Change
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

LocationDialog.show = (address: string, postalCode: string,  handleLocationConfirm: () => void,
        handleLocationChange: () => void) => {
    const existingModal = document.getElementById("location-model");
    if (existingModal) {
        return;
    }
    const modalContainer = document.createElement("div");
    modalContainer.id = "location-model";
    document.body.appendChild(modalContainer);
    const root = ReactDOM.createRoot(modalContainer);

    const closeModal = () => {
        root.unmount();
        document.body.removeChild(modalContainer);
    };

    root.render(
        <LocationDialog
            onClose={closeModal}
            address={address}
            postalCode={postalCode}
            handleLocationConfirm={handleLocationConfirm}
            handleLocationChange={handleLocationChange}
        />
    );
};

export default LocationDialog;
